if (!customElements.get('checkbox-form')) {
	class CheckboxForm extends HTMLElement {
		connectedCallback() {
			this.checkbox = this.querySelector('input[type="checkbox"]');
			this.variantId = this.checkbox.value;
			this.checkbox.addEventListener('change', this._handleChange.bind(this));
		}
		async _handleChange(event) {
      this.checkbox.disabled = true;
			const data = {
				updates: {
					[this.variantId]: event.target.checked ? 1 : 0,
				},
				sections: ['mini-cart'],
			};
			const response = await fetch(`${window.themeVariables.routes.cartUpdateUrl}.js`, {
				body: JSON.stringify(data),
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
			});
      this.checkbox.disabled = false;
			const responseJson = await response.json();
			if (response.ok) {
				if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
					return (window.location.href = `${Shopify.routes.root}cart`);
				}

				fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
					const cartContent = await response2.json();
					document.documentElement.dispatchEvent(
						new CustomEvent('cart:updated', {
							bubbles: true,
							detail: {
								cart: cartContent,
							},
						}),
					);
					cartContent['sections'] = responseJson['sections'];
					document.documentElement.dispatchEvent(
						new CustomEvent('cart:refresh', {
							bubbles: true,
							detail: {
								cart: cartContent,
							},
						}),
					);
				});
			}
		}
	}
	window.customElements.define('checkbox-form', CheckboxForm);
}
